function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import styled, { createGlobalStyle, useTheme } from 'styled-components';
import IconButton from '../../../elements/components/IconButton';
import Link from '../../../elements/components/Link';
import Sticky from '../../../elements/components/Sticky';
import Block from '../Block';
const GlobalStyle = createGlobalStyle([
    `html{scroll-padding-top:`,
    `px;}`
], (p)=>p.$offset);
const PageNavigationContainer = styled(Block).withConfig({
    componentId: "sc-3ad1ffaa-0"
})([
    ``,
    `{padding-left:`,
    `;padding-right:`,
    `;}overflow:hidden;transition:box-shadow 0.3s cubic-bezier(0.48,0,0.1,1) 0s;`,
    `;`
], (p)=>{
    var _p_theme_breakpoints_down, _p_theme_breakpoints;
    return (_p_theme_breakpoints_down = (_p_theme_breakpoints = p.theme.breakpoints).down) === null || _p_theme_breakpoints_down === void 0 ? void 0 : _p_theme_breakpoints_down.call(_p_theme_breakpoints, 'lg');
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, 1.5);
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, 1.5);
}, (p)=>p.$isStuck && 'box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.15);');
const StyledPageNavigation = styled.div.withConfig({
    componentId: "sc-3ad1ffaa-1"
})([
    `height:`,
    `px;margin:`,
    `;position:relative;display:flex;align-items:center;::before,::after{content:'';display:none;width:`,
    `px;transition:opacity 0.3s cubic-bezier(0.48,0,0.1,1) 0s;position:absolute;pointer-events:none;top:0;bottom:0;background:linear-gradient( 90deg,`,
    ` 0%,rgba(0,0,0,0) 100% );}::before{`,
    `{display:initial;opacity:`,
    `;}}::after{`,
    `{display:initial;opacity:`,
    `;}right:0;transform:rotate(180deg);}`
], (p)=>p.theme.pageNavigation.height, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, 0, -1.5);
}, (p)=>p.theme.pageNavigation.height, (p)=>p.theme.colors.background[p.$color], (p)=>{
    var _p_theme_breakpoints_up, _p_theme_breakpoints;
    return (_p_theme_breakpoints_up = (_p_theme_breakpoints = p.theme.breakpoints).up) === null || _p_theme_breakpoints_up === void 0 ? void 0 : _p_theme_breakpoints_up.call(_p_theme_breakpoints, 'lg');
}, (p)=>p.$showLeftFade ? 1 : 0, (p)=>{
    var _p_theme_breakpoints_up, _p_theme_breakpoints;
    return (_p_theme_breakpoints_up = (_p_theme_breakpoints = p.theme.breakpoints).up) === null || _p_theme_breakpoints_up === void 0 ? void 0 : _p_theme_breakpoints_up.call(_p_theme_breakpoints, 'lg');
}, (p)=>p.$showRightFade ? 1 : 0);
const ArrowButton = styled(IconButton).withConfig({
    componentId: "sc-3ad1ffaa-2"
})([
    `&&&{z-index:10;position:absolute;transition:0.3s;}&.left{left:`,
    `;`,
    `{left:`,
    `;}}&.right{right:`,
    `;`,
    `{right:`,
    `;}}`,
    `{display:none;}`,
    `{pointer-events:`,
    `;opacity:`,
    `;}`
], (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, -4);
}, (p)=>{
    var _p_theme_breakpoints_up, _p_theme_breakpoints;
    return (_p_theme_breakpoints_up = (_p_theme_breakpoints = p.theme.breakpoints).up) === null || _p_theme_breakpoints_up === void 0 ? void 0 : _p_theme_breakpoints_up.call(_p_theme_breakpoints, 'xl');
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, -6);
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, -4);
}, (p)=>{
    var _p_theme_breakpoints_up, _p_theme_breakpoints;
    return (_p_theme_breakpoints_up = (_p_theme_breakpoints = p.theme.breakpoints).up) === null || _p_theme_breakpoints_up === void 0 ? void 0 : _p_theme_breakpoints_up.call(_p_theme_breakpoints, 'xl');
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, -6);
}, (p)=>{
    var _p_theme_breakpoints_down, _p_theme_breakpoints;
    return (_p_theme_breakpoints_down = (_p_theme_breakpoints = p.theme.breakpoints).down) === null || _p_theme_breakpoints_down === void 0 ? void 0 : _p_theme_breakpoints_down.call(_p_theme_breakpoints, 'lg');
}, (p)=>{
    var _p_theme_breakpoints_up, _p_theme_breakpoints;
    return (_p_theme_breakpoints_up = (_p_theme_breakpoints = p.theme.breakpoints).up) === null || _p_theme_breakpoints_up === void 0 ? void 0 : _p_theme_breakpoints_up.call(_p_theme_breakpoints, 'lg');
}, (p)=>p.$display ? 'all' : 'none', (p)=>p.$display ? 1 : 0);
const LinksWrapper = styled.nav.withConfig({
    componentId: "sc-3ad1ffaa-3"
})([
    `position:relative;height:100%;display:flex;flex-wrap:nowrap;align-items:center;scroll-behavior:smooth;overflow-x:auto;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;`
]);
const StyledLink = styled(Link).withConfig({
    componentId: "sc-3ad1ffaa-4"
})([
    `height:100%;a{align-items:center;height:100%;padding:`,
    `;:focus-visible{box-shadow:inset `,
    `;}`,
    ` .link-text{height:100%;display:flex;align-items:center;}}`
], (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, 0, 1.5);
}, (p)=>`0 0 0 1px ${p.theme.colors.action.focus}`, (p)=>p.$disableLinkStyles && `&:active {
        background-color: transparent;
      }`);
const transitionSpeedVariants = {
    normal: 0.5,
    fast: 0.1
};
const StyledBar = styled.span.withConfig({
    componentId: "sc-3ad1ffaa-5"
})([
    `display:block;position:absolute;bottom:0;left:0;height:2px;background-color:`,
    `;width:`,
    `;transform:`,
    `;transition:`,
    `s cubic-bezier(0.48,0,0.1,1);`
], (p)=>{
    var _p_theme_colors_light_textStates_p_$colorVariant, _p_theme_colors_light;
    return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : (_p_theme_colors_light_textStates_p_$colorVariant = _p_theme_colors_light.textStates[p.$colorVariant]) === null || _p_theme_colors_light_textStates_p_$colorVariant === void 0 ? void 0 : _p_theme_colors_light_textStates_p_$colorVariant.default;
}, (p)=>`${p.$width}px`, (p)=>`translateX(${p.$offset ? `${p.$offset}px` : '-100%'})`, (p)=>transitionSpeedVariants[p.$transitionSpeed || 'normal']);
/**
 * The PageNavigation component allows you to create navigation within a page or to other pages
 * (when it is not feasible to add them to the main navigation on the Header).
 *
 * Keep in mind that you should not mix page and out of page links at the same time,
 * in order to align with user expectations of interaction outcomes.
 *
 * PageNavigation can also be used as a Tabs menu when a 'asTabsMenu' prop is passed.
 * When 'asTabsMenu' is set to true, the 'links' prop will be used to render the tabs items. In that case, make sure to pass an 'onClick' function to each link if you want to trigger an action when the tab is clicked.
 *
 * All other props will be forwarded to the root component.
 */ const PageNavigation = /*#__PURE__*/ forwardRef(function PageNavigation(_0, _1) {
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { links, color = 'default', offsetFromTop, className, asTabsMenu = false } = _ref1, other = _object_without_properties(_ref1, [
        "links",
        "color",
        "offsetFromTop",
        "className",
        "asTabsMenu"
    ]), [ref] = _rest;
    const [topOffset, setTopOffset] = useState(0);
    const [isStuck, setIsStuck] = useState(false);
    const [anchorReached, setAnchorReached] = useState(null);
    const [isScrollable, setIsScrollable] = useState({
        left: false,
        right: false
    });
    const [barWidth, setBarWidth] = useState(0);
    const [barOffset, setBarOffset] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const scrollRef = useRef(null);
    const anchorRef = useRef(null);
    const theme = useTheme();
    const themeHeaderHeight = theme.header.height;
    const navHeight = theme.pageNavigation.height;
    const anchorLinks = links.reduce((targets, { href })=>{
        if (typeof href === 'string' && href.startsWith('#')) return [
            ...targets,
            href
        ];
        return targets;
    }, []);
    useEffect(()=>{
        setTopOffset(offsetFromTop !== null && offsetFromTop !== void 0 ? offsetFromTop : themeHeaderHeight);
    }, [
        offsetFromTop,
        themeHeaderHeight
    ]);
    useEffect(()=>{
        // set isStuck when nav reaches top
        const cachedRef = scrollRef.current;
        const observer = new IntersectionObserver(([e])=>{
            const isStuck = Math.floor(e.boundingClientRect.y) <= topOffset;
            setIsStuck(isStuck);
        }, {
            threshold: 1,
            rootMargin: `-${topOffset + 1}px 0px`
        });
        if (cachedRef) {
            observer.observe(cachedRef);
        }
        return ()=>{
            if (cachedRef) {
                observer.unobserve(cachedRef);
            }
        };
    }, [
        scrollRef,
        topOffset
    ]);
    useEffect(()=>{
        if (anchorLinks.length > 0 && topOffset) {
            anchorLinks.forEach((anchor, index)=>{
                anchorRef.current = document.querySelector(anchor);
                if (anchorRef.current) {
                    const cachedRef = anchorRef.current;
                    const observer = new IntersectionObserver(([e])=>{
                        const isAnchorReached = e.boundingClientRect.y <= topOffset + navHeight;
                        if (isAnchorReached) {
                            setAnchorReached(()=>anchor);
                        }
                        if (!isAnchorReached && e.boundingClientRect.y < topOffset + navHeight + 400) {
                            setAnchorReached(()=>{
                                var _anchorLinks_;
                                return (_anchorLinks_ = anchorLinks[index - 1]) !== null && _anchorLinks_ !== void 0 ? _anchorLinks_ : 0;
                            });
                        }
                    }, {
                        threshold: 1,
                        rootMargin: `-${topOffset - 1 + navHeight}px 0px 9999px`
                    });
                    observer.observe(cachedRef);
                }
            });
        }
    }, [
        anchorLinks,
        navHeight,
        topOffset
    ]);
    useEffect(()=>{
        if (asTabsMenu) return; // does not apply to <Tabs /> component
        // animate bar on anchor reached
        if (scrollRef.current) {
            const cachedRef = scrollRef.current;
            const currentAnchor = cachedRef.querySelector(`[href*="${anchorReached}"]`);
            const currentAnchorText = currentAnchor === null || currentAnchor === void 0 ? void 0 : currentAnchor.children[0];
            const moveBarToAnchor = setTimeout(()=>{
                setBarWidth(()=>{
                    var _ref;
                    return (_ref = currentAnchorText === null || currentAnchorText === void 0 ? void 0 : currentAnchorText.clientWidth) !== null && _ref !== void 0 ? _ref : 0;
                });
                setBarOffset(()=>{
                    var _ref;
                    return (_ref = currentAnchorText === null || currentAnchorText === void 0 ? void 0 : currentAnchorText.offsetLeft) !== null && _ref !== void 0 ? _ref : 0;
                });
            }, 250);
            const scrollNavToAnchor = setTimeout(()=>{
                var _ref;
                cachedRef.scrollLeft = (_ref = currentAnchor === null || currentAnchor === void 0 ? void 0 : currentAnchor.offsetLeft) !== null && _ref !== void 0 ? _ref : 0;
            }, 500);
            return ()=>{
                clearTimeout(moveBarToAnchor);
                clearTimeout(scrollNavToAnchor);
            };
        }
    }, [
        scrollRef,
        anchorReached,
        asTabsMenu
    ]);
    useEffect(()=>{
        // set if nav is scrollable
        updateIsScrollable(scrollRef.current);
    }, []);
    const updateIsScrollable = (el)=>{
        if (!el) {
            return;
        }
        const newIsScrollable = {
            left: false,
            right: false
        };
        if (el.scrollLeft > 0) {
            newIsScrollable.left = true;
        }
        if (el.scrollWidth - el.offsetWidth - el.scrollLeft > 1) {
            newIsScrollable.right = true;
        }
        setIsScrollable(()=>newIsScrollable);
    };
    const updateScroll = (direction)=>{
        if (!scrollRef.current) {
            return null;
        }
        switch(direction){
            case 'left':
                scrollRef.current.scrollLeft -= scrollRef.current.offsetWidth;
                break;
            case 'right':
                scrollRef.current.scrollLeft += scrollRef.current.offsetWidth;
                break;
        }
        return null;
    };
    const isInverted = color === 'inverse';
    const linkColorVariant = isInverted ? 'inverse' : color === 'default' ? 'accent' : 'default';
    useEffect(()=>{
        var _scrollRef_current;
        if (!asTabsMenu) return;
        // pre-select first tab
        const firstElement = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.children[0];
        setActiveTab(0);
        setBarWidth(firstElement === null || firstElement === void 0 ? void 0 : firstElement.clientWidth);
        setBarOffset((firstElement === null || firstElement === void 0 ? void 0 : firstElement.offsetLeft) || 1);
    }, [
        asTabsMenu
    ]);
    const PageNavigationItems = useCallback(()=>{
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: links.map((link, index)=>{
                const linkProps = _object_spread_props(_object_spread({
                    id: anchorReached === link.href ? 'isReached' : '',
                    className: 'nav-link',
                    as: undefined,
                    TypographyProps: {
                        noWrap: true,
                        className: 'link-text',
                        weight: asTabsMenu && index === activeTab ? 'bold' : 'medium'
                    },
                    hoverVariant: asTabsMenu ? 'default' : linkColorVariant,
                    colorVariant: asTabsMenu ? 'default' : linkColorVariant
                }, link), {
                    onClick: (e)=>{
                        if (asTabsMenu) {
                            e.preventDefault(); // prevent page scroll
                            setActiveTab(index);
                            setBarWidth(e.currentTarget.clientWidth);
                            setBarOffset(e.currentTarget.offsetLeft || 1);
                        }
                        if (link.onClick) link.onClick(e);
                    }
                });
                return /*#__PURE__*/ _jsx(StyledLink, _object_spread({
                    $disableLinkStyles: asTabsMenu === true
                }, linkProps), index);
            })
        });
    }, [
        asTabsMenu,
        links,
        activeTab,
        anchorReached,
        linkColorVariant
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GlobalStyle, {
                $offset: topOffset + navHeight - 8
            }),
            /*#__PURE__*/ _jsx(Sticky, {
                disableSticky: asTabsMenu,
                fromTop: topOffset,
                zIndex: "pageNavigation",
                children: /*#__PURE__*/ _jsx(PageNavigationContainer, _object_spread_props(_object_spread({
                    noPaddingBottom: true,
                    noPaddingTop: true,
                    $isStuck: isStuck,
                    background: {
                        color: color
                    },
                    className: className
                }, other), {
                    children: /*#__PURE__*/ _jsxs(StyledPageNavigation, {
                        ref: ref,
                        $color: color,
                        $showLeftFade: isScrollable.left,
                        $showRightFade: isScrollable.right,
                        children: [
                            /*#__PURE__*/ _jsx(ArrowButton, {
                                $display: isScrollable.left,
                                className: "left",
                                color: isInverted ? 'inverse' : 'primary',
                                icon: "LeftArrow",
                                size: "medium",
                                variant: "ghost",
                                onClick: ()=>updateScroll('left')
                            }),
                            /*#__PURE__*/ _jsxs(LinksWrapper, {
                                ref: scrollRef,
                                onScroll: (e)=>updateIsScrollable(e.target),
                                children: [
                                    /*#__PURE__*/ _jsx(PageNavigationItems, {}),
                                    /*#__PURE__*/ _jsx(StyledBar, {
                                        $colorVariant: asTabsMenu ? 'default' : linkColorVariant,
                                        $offset: barOffset,
                                        $transitionSpeed: asTabsMenu ? 'fast' : 'normal',
                                        $width: barWidth
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ArrowButton, {
                                $display: isScrollable.right,
                                className: "right",
                                color: isInverted ? 'inverse' : 'primary',
                                icon: "RightArrow",
                                size: "medium",
                                variant: "ghost",
                                onClick: ()=>updateScroll('right')
                            })
                        ]
                    })
                }))
            })
        ]
    });
});
export default PageNavigation;
